module.exports = __webpack_public_path__ + "img/child-pink.1966d127.svg";